import computerRequestElements from './computer-request-elements';
import computerKendoWindow from './computer-kendo-window';
import technologyCopyRequestWindow from './technology-copy-request-window';
import createCapexRequestController from "../shared/capex-request-controller";

const controller = createCapexRequestController({
    baseUrl: '/Finance/CapExTechnologyRequest',
    submitAction: 'SubmitComputerRequest',
});

export const {
    getApprovalFormData,
    setApprovalControlsBusy,
    approveRequest,
    rejectRequest,
    approvalEvent,
    rejectionEvent,
} = controller;

export default function () {
    computerRequestElements();
    controller.init();
    computerKendoWindow();
    technologyCopyRequestWindow();
}
